import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import "../styles/GoogleSearch.css";

const GoogleSearch = () => {
  const [query, setQuery] = useState("Srijan Sareen");
  const [darkMode, setDarkMode] = useState(true);
  const [animate, setAnimate] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Start animation after component mounts
    setTimeout(() => setAnimate(true), 500);
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    if (query.toLowerCase() === "srijan sareen") {
      navigate("/overview");
    } else {
      alert("Try searching for 'Srijan Sareen'");
    }
  };

  return (
    <div className={`search-container ${darkMode ? "dark-mode" : "light-mode"}`}>
      {/* Navbar with About and Blog */}
      <div className="navbar">
        <Link to="/about" className="nav-link">About Me</Link>
        {/* <a href="/blog" className="nav-link">Blog</a> */}
      </div>

      {/* Toggle Light/Dark Mode */}
      <div className="toggle-wrapper">
        <label className="switch">
          <input type="checkbox" checked={darkMode} onChange={() => setDarkMode(!darkMode)} />
          <span className="slider"></span>
        </label>
      </div>

      {/* Google Logo Animation */}
      <h1 className="google-logo-lading-page">
        {["W", "E", "L", "C", "O", "M", "E"].map((letter, index) => (
          <span
            key={index}
            className={`letter letter-${index} ${animate ? "bounce" : ""}`}
          >
            {letter}
          </span>
        ))}
      </h1>

      {/* Search Form */}
      <form onSubmit={handleSearch} className="search-form">
        <div className="search-wrapper">
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className="search-input modern-input"
            placeholder="Search Google or type a URL"
          />
          <button type="submit" className="search-icon">
            🔍
          </button>
        </div>
        
        {/* Centered Buttons */}
        <div className="button-group">
          <button type="submit" className="search-button">Search</button>
          <button type="button" className="hire-me-button" onClick={() => navigate("/about")}>
            Hire Me
          </button>
        </div>
      </form>

      {/* Footer */}
      <footer className="footer">
        <p>Created by <span className="creator">Srijan Sareen</span></p>
      </footer>
    </div>
  );
};

export default GoogleSearch;
